import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface IntegrationsState {
  error: any
  access_level_success: any
  access_level_error: any
  go_live: any
  access_key_error: any
  access_levels: any
  access_keys: any
  endpoints: any
  sandbox_endpoints: any
  production_endpoints: any
  endpoint_error: any
  revoke_access: any
  accountSummary: any
  logs: any
}

export const useIntegrationsStore = defineStore('integrations', {
  state: (): IntegrationsState => ({
    error: null,
    access_level_success: null,
    access_level_error: null,
    go_live: null,
    access_key_error: null,
    access_levels: null,
    access_keys: null,
    endpoints: null,
    sandbox_endpoints: null,
    production_endpoints: null,
    endpoint_error: null,
    revoke_access: null,
    accountSummary: null,
    logs: null,
  }),

  getters: {
    getAccessLevels: (state) => state.access_levels,
    getAccessKeys: (state) => state.access_keys,
    getAccessLevelSuccess: (state) => state.access_level_success,
    getGeneratedAccessKey: (state) => state.access_keys,
    getAccessLevelError: (state) => state.access_level_error,
    getAccessKeyError: (state) => state.access_key_error,
    getEndpoints: (state) => state.endpoints,
    getSandboxEndpoints: (state) => state.sandbox_endpoints,
    getProductionEndpoints: (state) => state.production_endpoints,
    getRevokeAccess: (state) => state.revoke_access,
    getGoLive: (state) => state.go_live,
    getAccountSummary: (state) => state.accountSummary,
    getApiLogs: (state) => state.logs,
  },

  actions: {
    async fetchAccessLevels() {
      try {
        const response = await api().get('/api/third-party/level/all')
        this.access_levels = response.data
      } catch (error: any) {
        this.access_level_error = error.response?.data
      }
    },

    async doAddAccessAreas(data: any) {
      try {
        const response = await api().post('/third-party-api/access-list/create', data)
        this.access_level_success = response.data
      } catch (error: any) {
        this.access_level_error = error.response?.data
      }
    },

    async doRemoveAccessArea(data: any) {
      try {
        const payload = {
            userId: data.userId,
            endPointsToAdd: data.endPointsToAdd || [],
            endPointsToRemove: data.endPoints,
            apiMode: data.apiMode
        }
        const response = await api().post('/third-party-api/access-list/update', payload)
        this.access_level_success = response.data
      } catch (error: any) {
        this.access_level_error = error.response?.data
      }
    },

    async generateAccessKeys(data: any) {
      try {
        const response = await api().post('/third-party-api/access/setup', data)
        this.access_keys = response.data
      } catch (error: any) {
        this.access_key_error = error.response?.data
      }
    },

    async doGoLive(data: any) {
      try {
        const response = await api().post('/third-party-api/access/go-live', data)
        this.go_live = response.data
      } catch (error: any) {
        this.access_key_error = error.response?.data
      }
    },

    async doRevokeAccess(data: any) {
      try {
        const response = await api().post('/third-party-api/access/revoke', data)
        this.revoke_access = response.data
      } catch (error: any) {
        this.access_key_error = error.response?.data
      }
    },

    async fetchAccessKeys(data: any) {
      try {
        const response = await api().get('/api/third-party/access-key/by-account/' + data.id)
        this.access_keys = response.data
      } catch (error: any) {
        this.access_key_error = error.response?.data
      }
    },

    async fetchAllEndpoints() {
      try {
        const response = await api().get('/third-party-api/endpoint/all')
        this.endpoints = response.data
      } catch (error: any) {
        this.endpoint_error = error.response?.data
      }
    },

    async fetchApiLogs(data: string) {
      try {
        const response = await api().get('/third-party-access/request-logs?' + data)
        this.logs = response.data
      } catch (error: any) {
        this.endpoint_error = error.response?.data
      }
    },

    async fetchUserProductionEndpoints(userId: string | number) {
      try {
        const response = await api().get('/third-party-api/access/live/' + userId)
        this.production_endpoints = response.data
      } catch (error: any) {
        this.endpoint_error = error.response?.data
      }
    },

    async fetchUserSandboxEndpoints(userId: string | number) {
      try {
        const response = await api().get('/third-party-api/access/sandbox/' + userId)
        this.sandbox_endpoints = response.data
      } catch (error: any) {
        this.endpoint_error = error.response?.data
      }
    },

    async fetchAccountSummary(userId: string | number) {
      try {
        const response = await api().get('/billing/transaction/partner-account/' + userId)
        this.accountSummary = response.data
      } catch (error: any) {
        this.endpoint_error = error.response?.data
      }
    },
  },
})
